import React from 'react';
import { ScrollView } from 'react-native';

import Container from '@src/components/Container';
import VisibleStatusBar from '@src/components/VisibleStatusBar';
import useAnimatedHeader from '@src/hooks/useAnimatedHeader';
import { Gradient } from '@src/screens/Authentication/styled';

import { Background } from './styled';
import { Props } from './types';

const Screen: React.FC<Props> = () => {
  const handleScroll = useAnimatedHeader();

  return (
    <>
      <VisibleStatusBar />
      <Container>
        <Background source={require('@src/assets/images/tourLeader.jpg')}>
          <Gradient
            locations={[0.2, 0.5, 0.8]}
            colors={['#F2F2F2', 'rgba(255,255,255,0)', '#F2F2F2']}
          />
        </Background>
        <ScrollView scrollEventThrottle={16} onScroll={handleScroll} />
      </Container>
    </>
  );
};

Screen.displayName = 'PrimeTripAdvisor';

export default Screen;
